import React from "react";
import styled, { keyframes } from "styled-components";
import { IoPulseSharp } from "react-icons/io5";
import AnimationEvent from "../assets/wired-flat-1249-heart-beat-hover-heart-beat.gif";
import cameraIcon from "../assets/lucide-scan-face.svg";
import { MdWarning, MdError } from "react-icons/md";

const slideIn = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

const pulseAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
`;

const ModalContainer = styled.div<{ isOpen: boolean }>`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  border-radius: 35px 35px 0 0;
  box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-height: 300px;
  padding: 20px;
  transform: ${({ isOpen }) => (isOpen ? "translateY(0)" : "translateY(100%)")};
  animation: ${({ isOpen }) => (isOpen ? slideIn : "none")} 0.3s forwards;
  z-index: 1001;
  text-align: center;
  color: #ffffff;
  @media (max-width: 768px) {
    max-width: 91%;
  }
`;

const ModalContent = styled.div`
  position: relative;
`;

const Text = styled.h3`
  padding-bottom: 10px;
  font-size: 22px;
  font-weight: normal;
  color: black;
  text-align: left;
`;

const InstructionText = styled.p<{ isAlert: boolean }>`
  font-size: 25px;
  color: ${({ isAlert }) => (isAlert ? "#ff0000" : "#ffc107")};
  text-align: left;
`;

const ProgressBarContainer = styled.div`
  width: 100%;
  height: 4px;
  background-color: #e0e0e0;
  border-radius: 2px;
  overflow: hidden;
  margin-top: 30px;
`;

const progressAnimation = keyframes`
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
`;

const ProgressBar = styled.div`
  height: 100%;
  background-color: #4caf50;
  animation: ${progressAnimation} 60s linear forwards;
`;

const PulseIcon = styled(IoPulseSharp)`
  color: red;
  font-size: 80px; /* Adjust size as desired */
  margin-bottom: 12%;
  animation: ${pulseAnimation} 1.5s infinite; /* Pulsing animation */
`;

const SVGContainer = styled.div`
  width: 100%;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
`;
const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  img {
    width: 42px;
    height: 42px;
    margin-right: 5px;
  }
`;

const FaceScanModal = ({ isOpen, onClose, onMessage, isMeasuring }) => {
  if (!isOpen) return null;

  return (
    <ModalContainer isOpen={isOpen}>
      <ModalContent>
        <IconWrapper>
          <img src={cameraIcon} alt="Camera Icon" />
        </IconWrapper>
        <Text>Scanning Your Face</Text>
        <InstructionText isAlert={!!onMessage}>
          {onMessage ? (
            <span>
              <span style={{ paddingRight: "10px" }}>
                <MdError />{" "}
              </span>{" "}
              {onMessage}
            </span>
          ) : (
            <span>
              <span style={{ paddingRight: "10px" }}>
                <MdWarning />
              </span>
              Avoid moving or talking
            </span>
          )}
        </InstructionText>

        {/* Pulsing Icon */}
        <SVGContainer>
          <img src={AnimationEvent} style={{ height: "100px" , width: "100px"}} alt="Loading Animation" />
        </SVGContainer>

        <ProgressBarContainer>
          {isMeasuring ? (
            <ProgressBar />
          ) : (
            "Please Reload the Page & Start Again"
          )}
        </ProgressBarContainer>
      </ModalContent>
    </ModalContainer>
  );
};

export default FaceScanModal;
